/* tslint:disable */
/* eslint-disable */
/**
 * Solaris User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ActivatePhysicalCard201Response } from '../model';
// @ts-ignore
import { ActivatePhysicalCard400Response } from '../model';
// @ts-ignore
import { ActivatePhysicalCard401Response } from '../model';
// @ts-ignore
import { ActivatePhysicalCard403Response } from '../model';
// @ts-ignore
import { ActivatePhysicalCard404Response } from '../model';
// @ts-ignore
import { ActivatePhysicalCardRequest } from '../model';
// @ts-ignore
import { ActivateRenewalCard201Response } from '../model';
// @ts-ignore
import { ActivateRenewalCard400Response } from '../model';
// @ts-ignore
import { ActivateRenewalCard401Response } from '../model';
// @ts-ignore
import { ActivateRenewalCard403Response } from '../model';
// @ts-ignore
import { ActivateRenewalCard404Response } from '../model';
// @ts-ignore
import { ActivateRenewalCardRequest } from '../model';
// @ts-ignore
import { GetCard200Response } from '../model';
// @ts-ignore
import { GetCard400Response } from '../model';
// @ts-ignore
import { GetCard401Response } from '../model';
// @ts-ignore
import { GetCard403Response } from '../model';
// @ts-ignore
import { GetCard404Response } from '../model';
// @ts-ignore
import { GetCardActivationStatus200Response } from '../model';
// @ts-ignore
import { GetCardActivationStatus400Response } from '../model';
// @ts-ignore
import { GetCardActivationStatus401Response } from '../model';
// @ts-ignore
import { GetCardActivationStatus403Response } from '../model';
// @ts-ignore
import { GetCardActivationStatus404Response } from '../model';
// @ts-ignore
import { GetCardActivationStatusRequest } from '../model';
// @ts-ignore
import { GetEncryptedPinBlockByCzpk200Response } from '../model';
// @ts-ignore
import { GetEncryptedPinBlockByCzpk401Response } from '../model';
// @ts-ignore
import { GetEncryptedPinBlockByCzpk403Response } from '../model';
// @ts-ignore
import { GetEncryptedPinBlockByCzpk404Response } from '../model';
// @ts-ignore
import { GetEncryptedPinBlockByCzpkRequest } from '../model';
// @ts-ignore
import { GetEncryptedPinRetrievalKey200Response } from '../model';
// @ts-ignore
import { GetEncryptedPinRetrievalKey401Response } from '../model';
// @ts-ignore
import { GetEncryptedPinRetrievalKey403Response } from '../model';
// @ts-ignore
import { GetEncryptedPinRetrievalKey404Response } from '../model';
// @ts-ignore
import { GetEncryptedPinRetrievalKeyRequest } from '../model';
// @ts-ignore
import { GetHSMPublicKey200Response } from '../model';
// @ts-ignore
import { GetHSMPublicKey401Response } from '../model';
// @ts-ignore
import { GetHSMPublicKey403Response } from '../model';
// @ts-ignore
import { GetHSMPublicKey404Response } from '../model';
// @ts-ignore
import { IssueVirtualCard201Response } from '../model';
// @ts-ignore
import { IssueVirtualCard400Response } from '../model';
// @ts-ignore
import { IssueVirtualCard401Response } from '../model';
// @ts-ignore
import { IssueVirtualCard403Response } from '../model';
// @ts-ignore
import { IssueVirtualCard404Response } from '../model';
// @ts-ignore
import { IssueVirtualCardRequest } from '../model';
// @ts-ignore
import { RenewalCard201Response } from '../model';
// @ts-ignore
import { RenewalCard400Response } from '../model';
// @ts-ignore
import { RenewalCard401Response } from '../model';
// @ts-ignore
import { RenewalCard403Response } from '../model';
// @ts-ignore
import { RenewalCard404Response } from '../model';
// @ts-ignore
import { RenewalCardRequest } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest200Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest400Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest401Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest403Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest404Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequest409Response } from '../model';
// @ts-ignore
import { SpecifyPinForPhysicalCardIssuanceRequestRequest } from '../model';
/**
 * CardApi - axios parameter creator
 * @export
 */
export const CardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate physical card. `card:activate` scope is required in the JWT token. 
         * @summary Activate physical card
         * @param {ActivatePhysicalCardRequest} activatePhysicalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePhysicalCard: async (activatePhysicalCardRequest: ActivatePhysicalCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activatePhysicalCardRequest' is not null or undefined
            assertParamExists('activatePhysicalCard', 'activatePhysicalCardRequest', activatePhysicalCardRequest)
            const localVarPath = `/v1/cards/physical/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activatePhysicalCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate renewal requested card. `card:activate` scope is required in the JWT token. 
         * @summary activate renewal card
         * @param {ActivateRenewalCardRequest} activateRenewalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateRenewalCard: async (activateRenewalCardRequest: ActivateRenewalCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateRenewalCardRequest' is not null or undefined
            assertParamExists('activateRenewalCard', 'activateRenewalCardRequest', activateRenewalCardRequest)
            const localVarPath = `/v1/cards/renewal/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateRenewalCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves detailed information about a specific card. The cardId in the path parameter must match the one in the JWT token context. `card:read` scope is required in the JWT token. 
         * @summary Get card information
         * @param {string} id Unique identifier of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCard', 'id', id)
            const localVarPath = `/v1/cards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get physical card activation status. `card:read` scope is required in the JWT token. 
         * @summary Get physical card activation status
         * @param {GetCardActivationStatusRequest} getCardActivationStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardActivationStatus: async (getCardActivationStatusRequest: GetCardActivationStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCardActivationStatusRequest' is not null or undefined
            assertParamExists('getCardActivationStatus', 'getCardActivationStatusRequest', getCardActivationStatusRequest)
            const localVarPath = `/v1/cards/physical/activation_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCardActivationStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves encrypted pin block by czpk. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin block by czpk
         * @param {GetEncryptedPinBlockByCzpkRequest} getEncryptedPinBlockByCzpkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedPinBlockByCzpk: async (getEncryptedPinBlockByCzpkRequest: GetEncryptedPinBlockByCzpkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getEncryptedPinBlockByCzpkRequest' is not null or undefined
            assertParamExists('getEncryptedPinBlockByCzpk', 'getEncryptedPinBlockByCzpkRequest', getEncryptedPinBlockByCzpkRequest)
            const localVarPath = `/v1/cards/pin/encrypted_with_czpk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getEncryptedPinBlockByCzpkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves encrypted pin retrieval key. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin retrieval key
         * @param {GetEncryptedPinRetrievalKeyRequest} getEncryptedPinRetrievalKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedPinRetrievalKey: async (getEncryptedPinRetrievalKeyRequest: GetEncryptedPinRetrievalKeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getEncryptedPinRetrievalKeyRequest' is not null or undefined
            assertParamExists('getEncryptedPinRetrievalKey', 'getEncryptedPinRetrievalKeyRequest', getEncryptedPinRetrievalKeyRequest)
            const localVarPath = `/v1/cards/pin/encrypted_retrieval_key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getEncryptedPinRetrievalKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves HSM public key for ZPK encryption. `card:read` scope is required in the JWT token. 
         * @summary Get HSM public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHSMPublicKey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cards/pin/hsm_pubkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issues a virtual card for a reserved or deactivated card account. The cardAccountId in the request body must match the one in the JWT token context. `card:activate` scope is required in the JWT token. 
         * @summary Issue a virtual card
         * @param {IssueVirtualCardRequest} issueVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueVirtualCard: async (issueVirtualCardRequest: IssueVirtualCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issueVirtualCardRequest' is not null or undefined
            assertParamExists('issueVirtualCard', 'issueVirtualCardRequest', issueVirtualCardRequest)
            const localVarPath = `/v1/cards/virtual/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(issueVirtualCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Order renewal card with designated PIN and name The cardAccountId in the request body must match the one in the JWT token context. `card:request` scope is required in the JWT token. 
         * @summary order renewal card
         * @param {RenewalCardRequest} renewalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewalCard: async (renewalCardRequest: RenewalCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'renewalCardRequest' is not null or undefined
            assertParamExists('renewalCard', 'renewalCardRequest', renewalCardRequest)
            const localVarPath = `/v1/cards/renewal/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renewalCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Specify PIN and name for a physical card issuance request. `card:request` scope is required in the JWT token. 
         * @summary Specify PIN for physical card issuance request
         * @param {string} issuanceRequestId Physical card issuance request identifier
         * @param {SpecifyPinForPhysicalCardIssuanceRequestRequest} specifyPinForPhysicalCardIssuanceRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specifyPinForPhysicalCardIssuanceRequest: async (issuanceRequestId: string, specifyPinForPhysicalCardIssuanceRequestRequest: SpecifyPinForPhysicalCardIssuanceRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuanceRequestId' is not null or undefined
            assertParamExists('specifyPinForPhysicalCardIssuanceRequest', 'issuanceRequestId', issuanceRequestId)
            // verify required parameter 'specifyPinForPhysicalCardIssuanceRequestRequest' is not null or undefined
            assertParamExists('specifyPinForPhysicalCardIssuanceRequest', 'specifyPinForPhysicalCardIssuanceRequestRequest', specifyPinForPhysicalCardIssuanceRequestRequest)
            const localVarPath = `/v1/cards/physical/issuance-requests/{issuanceRequestId}/pin`
                .replace(`{${"issuanceRequestId"}}`, encodeURIComponent(String(issuanceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specifyPinForPhysicalCardIssuanceRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardApi - functional programming interface
 * @export
 */
export const CardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate physical card. `card:activate` scope is required in the JWT token. 
         * @summary Activate physical card
         * @param {ActivatePhysicalCardRequest} activatePhysicalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePhysicalCard(activatePhysicalCardRequest: ActivatePhysicalCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivatePhysicalCard201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePhysicalCard(activatePhysicalCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Activate renewal requested card. `card:activate` scope is required in the JWT token. 
         * @summary activate renewal card
         * @param {ActivateRenewalCardRequest} activateRenewalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateRenewalCard(activateRenewalCardRequest: ActivateRenewalCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivateRenewalCard201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateRenewalCard(activateRenewalCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves detailed information about a specific card. The cardId in the path parameter must match the one in the JWT token context. `card:read` scope is required in the JWT token. 
         * @summary Get card information
         * @param {string} id Unique identifier of the card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCard(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCard(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get physical card activation status. `card:read` scope is required in the JWT token. 
         * @summary Get physical card activation status
         * @param {GetCardActivationStatusRequest} getCardActivationStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardActivationStatus(getCardActivationStatusRequest: GetCardActivationStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardActivationStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardActivationStatus(getCardActivationStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves encrypted pin block by czpk. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin block by czpk
         * @param {GetEncryptedPinBlockByCzpkRequest} getEncryptedPinBlockByCzpkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptedPinBlockByCzpk(getEncryptedPinBlockByCzpkRequest: GetEncryptedPinBlockByCzpkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEncryptedPinBlockByCzpk200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptedPinBlockByCzpk(getEncryptedPinBlockByCzpkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves encrypted pin retrieval key. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin retrieval key
         * @param {GetEncryptedPinRetrievalKeyRequest} getEncryptedPinRetrievalKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptedPinRetrievalKey(getEncryptedPinRetrievalKeyRequest: GetEncryptedPinRetrievalKeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEncryptedPinRetrievalKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptedPinRetrievalKey(getEncryptedPinRetrievalKeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves HSM public key for ZPK encryption. `card:read` scope is required in the JWT token. 
         * @summary Get HSM public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHSMPublicKey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHSMPublicKey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHSMPublicKey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Issues a virtual card for a reserved or deactivated card account. The cardAccountId in the request body must match the one in the JWT token context. `card:activate` scope is required in the JWT token. 
         * @summary Issue a virtual card
         * @param {IssueVirtualCardRequest} issueVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueVirtualCard(issueVirtualCardRequest: IssueVirtualCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueVirtualCard201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueVirtualCard(issueVirtualCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Order renewal card with designated PIN and name The cardAccountId in the request body must match the one in the JWT token context. `card:request` scope is required in the JWT token. 
         * @summary order renewal card
         * @param {RenewalCardRequest} renewalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewalCard(renewalCardRequest: RenewalCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenewalCard201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewalCard(renewalCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Specify PIN and name for a physical card issuance request. `card:request` scope is required in the JWT token. 
         * @summary Specify PIN for physical card issuance request
         * @param {string} issuanceRequestId Physical card issuance request identifier
         * @param {SpecifyPinForPhysicalCardIssuanceRequestRequest} specifyPinForPhysicalCardIssuanceRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specifyPinForPhysicalCardIssuanceRequest(issuanceRequestId: string, specifyPinForPhysicalCardIssuanceRequestRequest: SpecifyPinForPhysicalCardIssuanceRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecifyPinForPhysicalCardIssuanceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specifyPinForPhysicalCardIssuanceRequest(issuanceRequestId, specifyPinForPhysicalCardIssuanceRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CardApi - factory interface
 * @export
 */
export const CardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardApiFp(configuration)
    return {
        /**
         * Activate physical card. `card:activate` scope is required in the JWT token. 
         * @summary Activate physical card
         * @param {CardApiActivatePhysicalCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePhysicalCard(requestParameters: CardApiActivatePhysicalCardRequest, options?: AxiosRequestConfig): AxiosPromise<ActivatePhysicalCard201Response> {
            return localVarFp.activatePhysicalCard(requestParameters.activatePhysicalCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate renewal requested card. `card:activate` scope is required in the JWT token. 
         * @summary activate renewal card
         * @param {CardApiActivateRenewalCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateRenewalCard(requestParameters: CardApiActivateRenewalCardRequest, options?: AxiosRequestConfig): AxiosPromise<ActivateRenewalCard201Response> {
            return localVarFp.activateRenewalCard(requestParameters.activateRenewalCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves detailed information about a specific card. The cardId in the path parameter must match the one in the JWT token context. `card:read` scope is required in the JWT token. 
         * @summary Get card information
         * @param {CardApiGetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard(requestParameters: CardApiGetCardRequest, options?: AxiosRequestConfig): AxiosPromise<GetCard200Response> {
            return localVarFp.getCard(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get physical card activation status. `card:read` scope is required in the JWT token. 
         * @summary Get physical card activation status
         * @param {CardApiGetCardActivationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardActivationStatus(requestParameters: CardApiGetCardActivationStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardActivationStatus200Response> {
            return localVarFp.getCardActivationStatus(requestParameters.getCardActivationStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves encrypted pin block by czpk. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin block by czpk
         * @param {CardApiGetEncryptedPinBlockByCzpkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedPinBlockByCzpk(requestParameters: CardApiGetEncryptedPinBlockByCzpkRequest, options?: AxiosRequestConfig): AxiosPromise<GetEncryptedPinBlockByCzpk200Response> {
            return localVarFp.getEncryptedPinBlockByCzpk(requestParameters.getEncryptedPinBlockByCzpkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves encrypted pin retrieval key. `card:read` scope is required in the JWT token. 
         * @summary Get encrypted pin retrieval key
         * @param {CardApiGetEncryptedPinRetrievalKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedPinRetrievalKey(requestParameters: CardApiGetEncryptedPinRetrievalKeyRequest, options?: AxiosRequestConfig): AxiosPromise<GetEncryptedPinRetrievalKey200Response> {
            return localVarFp.getEncryptedPinRetrievalKey(requestParameters.getEncryptedPinRetrievalKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves HSM public key for ZPK encryption. `card:read` scope is required in the JWT token. 
         * @summary Get HSM public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHSMPublicKey(options?: AxiosRequestConfig): AxiosPromise<GetHSMPublicKey200Response> {
            return localVarFp.getHSMPublicKey(options).then((request) => request(axios, basePath));
        },
        /**
         * Issues a virtual card for a reserved or deactivated card account. The cardAccountId in the request body must match the one in the JWT token context. `card:activate` scope is required in the JWT token. 
         * @summary Issue a virtual card
         * @param {CardApiIssueVirtualCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueVirtualCard(requestParameters: CardApiIssueVirtualCardRequest, options?: AxiosRequestConfig): AxiosPromise<IssueVirtualCard201Response> {
            return localVarFp.issueVirtualCard(requestParameters.issueVirtualCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Order renewal card with designated PIN and name The cardAccountId in the request body must match the one in the JWT token context. `card:request` scope is required in the JWT token. 
         * @summary order renewal card
         * @param {CardApiRenewalCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewalCard(requestParameters: CardApiRenewalCardRequest, options?: AxiosRequestConfig): AxiosPromise<RenewalCard201Response> {
            return localVarFp.renewalCard(requestParameters.renewalCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Specify PIN and name for a physical card issuance request. `card:request` scope is required in the JWT token. 
         * @summary Specify PIN for physical card issuance request
         * @param {CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specifyPinForPhysicalCardIssuanceRequest(requestParameters: CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<SpecifyPinForPhysicalCardIssuanceRequest200Response> {
            return localVarFp.specifyPinForPhysicalCardIssuanceRequest(requestParameters.issuanceRequestId, requestParameters.specifyPinForPhysicalCardIssuanceRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activatePhysicalCard operation in CardApi.
 * @export
 * @interface CardApiActivatePhysicalCardRequest
 */
export interface CardApiActivatePhysicalCardRequest {
    /**
     * 
     * @type {ActivatePhysicalCardRequest}
     * @memberof CardApiActivatePhysicalCard
     */
    readonly activatePhysicalCardRequest: ActivatePhysicalCardRequest
}

/**
 * Request parameters for activateRenewalCard operation in CardApi.
 * @export
 * @interface CardApiActivateRenewalCardRequest
 */
export interface CardApiActivateRenewalCardRequest {
    /**
     * 
     * @type {ActivateRenewalCardRequest}
     * @memberof CardApiActivateRenewalCard
     */
    readonly activateRenewalCardRequest: ActivateRenewalCardRequest
}

/**
 * Request parameters for getCard operation in CardApi.
 * @export
 * @interface CardApiGetCardRequest
 */
export interface CardApiGetCardRequest {
    /**
     * Unique identifier of the card
     * @type {string}
     * @memberof CardApiGetCard
     */
    readonly id: string
}

/**
 * Request parameters for getCardActivationStatus operation in CardApi.
 * @export
 * @interface CardApiGetCardActivationStatusRequest
 */
export interface CardApiGetCardActivationStatusRequest {
    /**
     * 
     * @type {GetCardActivationStatusRequest}
     * @memberof CardApiGetCardActivationStatus
     */
    readonly getCardActivationStatusRequest: GetCardActivationStatusRequest
}

/**
 * Request parameters for getEncryptedPinBlockByCzpk operation in CardApi.
 * @export
 * @interface CardApiGetEncryptedPinBlockByCzpkRequest
 */
export interface CardApiGetEncryptedPinBlockByCzpkRequest {
    /**
     * 
     * @type {GetEncryptedPinBlockByCzpkRequest}
     * @memberof CardApiGetEncryptedPinBlockByCzpk
     */
    readonly getEncryptedPinBlockByCzpkRequest: GetEncryptedPinBlockByCzpkRequest
}

/**
 * Request parameters for getEncryptedPinRetrievalKey operation in CardApi.
 * @export
 * @interface CardApiGetEncryptedPinRetrievalKeyRequest
 */
export interface CardApiGetEncryptedPinRetrievalKeyRequest {
    /**
     * 
     * @type {GetEncryptedPinRetrievalKeyRequest}
     * @memberof CardApiGetEncryptedPinRetrievalKey
     */
    readonly getEncryptedPinRetrievalKeyRequest: GetEncryptedPinRetrievalKeyRequest
}

/**
 * Request parameters for issueVirtualCard operation in CardApi.
 * @export
 * @interface CardApiIssueVirtualCardRequest
 */
export interface CardApiIssueVirtualCardRequest {
    /**
     * 
     * @type {IssueVirtualCardRequest}
     * @memberof CardApiIssueVirtualCard
     */
    readonly issueVirtualCardRequest: IssueVirtualCardRequest
}

/**
 * Request parameters for renewalCard operation in CardApi.
 * @export
 * @interface CardApiRenewalCardRequest
 */
export interface CardApiRenewalCardRequest {
    /**
     * 
     * @type {RenewalCardRequest}
     * @memberof CardApiRenewalCard
     */
    readonly renewalCardRequest: RenewalCardRequest
}

/**
 * Request parameters for specifyPinForPhysicalCardIssuanceRequest operation in CardApi.
 * @export
 * @interface CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest
 */
export interface CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest {
    /**
     * Physical card issuance request identifier
     * @type {string}
     * @memberof CardApiSpecifyPinForPhysicalCardIssuanceRequest
     */
    readonly issuanceRequestId: string

    /**
     * 
     * @type {SpecifyPinForPhysicalCardIssuanceRequestRequest}
     * @memberof CardApiSpecifyPinForPhysicalCardIssuanceRequest
     */
    readonly specifyPinForPhysicalCardIssuanceRequestRequest: SpecifyPinForPhysicalCardIssuanceRequestRequest
}

/**
 * CardApi - object-oriented interface
 * @export
 * @class CardApi
 * @extends {BaseAPI}
 */
export class CardApi extends BaseAPI {
    /**
     * Activate physical card. `card:activate` scope is required in the JWT token. 
     * @summary Activate physical card
     * @param {CardApiActivatePhysicalCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public activatePhysicalCard(requestParameters: CardApiActivatePhysicalCardRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).activatePhysicalCard(requestParameters.activatePhysicalCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate renewal requested card. `card:activate` scope is required in the JWT token. 
     * @summary activate renewal card
     * @param {CardApiActivateRenewalCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public activateRenewalCard(requestParameters: CardApiActivateRenewalCardRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).activateRenewalCard(requestParameters.activateRenewalCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves detailed information about a specific card. The cardId in the path parameter must match the one in the JWT token context. `card:read` scope is required in the JWT token. 
     * @summary Get card information
     * @param {CardApiGetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getCard(requestParameters: CardApiGetCardRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).getCard(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get physical card activation status. `card:read` scope is required in the JWT token. 
     * @summary Get physical card activation status
     * @param {CardApiGetCardActivationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getCardActivationStatus(requestParameters: CardApiGetCardActivationStatusRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).getCardActivationStatus(requestParameters.getCardActivationStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves encrypted pin block by czpk. `card:read` scope is required in the JWT token. 
     * @summary Get encrypted pin block by czpk
     * @param {CardApiGetEncryptedPinBlockByCzpkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getEncryptedPinBlockByCzpk(requestParameters: CardApiGetEncryptedPinBlockByCzpkRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).getEncryptedPinBlockByCzpk(requestParameters.getEncryptedPinBlockByCzpkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves encrypted pin retrieval key. `card:read` scope is required in the JWT token. 
     * @summary Get encrypted pin retrieval key
     * @param {CardApiGetEncryptedPinRetrievalKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getEncryptedPinRetrievalKey(requestParameters: CardApiGetEncryptedPinRetrievalKeyRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).getEncryptedPinRetrievalKey(requestParameters.getEncryptedPinRetrievalKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves HSM public key for ZPK encryption. `card:read` scope is required in the JWT token. 
     * @summary Get HSM public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public getHSMPublicKey(options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).getHSMPublicKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issues a virtual card for a reserved or deactivated card account. The cardAccountId in the request body must match the one in the JWT token context. `card:activate` scope is required in the JWT token. 
     * @summary Issue a virtual card
     * @param {CardApiIssueVirtualCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public issueVirtualCard(requestParameters: CardApiIssueVirtualCardRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).issueVirtualCard(requestParameters.issueVirtualCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Order renewal card with designated PIN and name The cardAccountId in the request body must match the one in the JWT token context. `card:request` scope is required in the JWT token. 
     * @summary order renewal card
     * @param {CardApiRenewalCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public renewalCard(requestParameters: CardApiRenewalCardRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).renewalCard(requestParameters.renewalCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Specify PIN and name for a physical card issuance request. `card:request` scope is required in the JWT token. 
     * @summary Specify PIN for physical card issuance request
     * @param {CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardApi
     */
    public specifyPinForPhysicalCardIssuanceRequest(requestParameters: CardApiSpecifyPinForPhysicalCardIssuanceRequestRequest, options?: AxiosRequestConfig) {
        return CardApiFp(this.configuration).specifyPinForPhysicalCardIssuanceRequest(requestParameters.issuanceRequestId, requestParameters.specifyPinForPhysicalCardIssuanceRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
